{
  "title": "Access",
  "subtitlePlatform": "Everybody who has signed in to the portal. Somebody who signs in without an invitation appears here holding nothing, and stays on the awaiting-access screen until they are granted something.",
  "subtitleTenant": "People who can reach this tenant. Invite somebody who has not signed in yet, or grant access to somebody who has.",
  "partnerTitle": "Partner team",
  "partnerSubtitle": "People who can administer this partner book — invite customers, manage signatures across your customers, and invite other partner administrators.",
  "partnerInviteHint": "They become a partner administrator for this book. Sign-in is all it takes — the role applies the first time they arrive.",
  "nobodyYetPartner": "No partner administrators yet besides invitations waiting to be taken up. Invite a colleague by the address they will sign in with.",
  "inviteSomebody": "Invite somebody",
  "grantAccess": "Grant access",
  "waitingTitle": "Waiting to be taken up",
  "waitingHint": "The role applies itself when they first sign in.",
  "invitationsAria": "Outstanding invitations",
  "colInvited": "Invited",
  "colExpires": "Expires",
  "colWillReceive": "Will receive",
  "invitedBy": "by {{name}}",
  "withdraw": "Withdraw",
  "withdrawAria": "Withdraw the invitation for {{email}}",
  "notWithdrawn": "Not withdrawn",
  "withdrawError": "Could not withdraw that invitation.",
  "nobodyYet": "Nobody yet",
  "nobodyYetTenant": "No one has been given access to this tenant. Invite somebody and the access is waiting for them the first time they sign in.",
  "nobodyYetPlatform": "Nobody has signed in yet. Invite somebody by the address they will sign in with, and their role applies itself the moment they arrive.",
  "peopleAria": "People",
  "colPerson": "Person",
  "colLastSignIn": "Last sign-in",
  "colAccess": "Access",
  "notRevoked": "Not revoked",
  "revokeError": "Could not revoke that.",
  "noAccessYet": "No access yet",
  "revoke": "Revoke",
  "revokeOwnerOnly": "Only a platform owner can revoke ownership",
  "revokeAria": "Revoke {{role}}{{tenant}}",
  "onTenant": " on {{name}}",
  "nobodyToGrant": "Nobody to grant to yet — this list is people who have already signed in. Invite them instead and the role applies itself when they arrive.",
  "personPlaceholder": "Choose somebody who has signed in",
  "role": "Role",
  "rolePlaceholder": "Choose a role",
  "tenant": "Tenant",
  "tenantPlaceholder": "Choose a tenant",
  "grant": "Grant",
  "accessGranted": "Access granted.",
  "notGranted": "Not granted",
  "grantError": "Could not grant that.",
  "inviteTitle": "Invite somebody",
  "inviteHint": "They do not need an account here. Sign-in is all it takes — the role below is applied the first time they arrive.",
  "workEmail": "Work email",
  "workEmailDesc": "The address they will sign in with.",
  "differentOrg": "They sign in from a different organisation",
  "differentOrgDesc": "Tick this for a customer's own administrator. Leave it for a colleague.",
  "theirDirectory": "Their directory",
  "theirDirectoryPlaceholder": "Entra tenant id, or Google Workspace domain",
  "theirDirectoryDesc": "Asked for because an email address alone proves nothing — anyone can create that address in a directory they control. The invitation only works from the directory named here.",
  "sendInvitation": "Send invitation",
  "invitedEmailed": "Invited {{email}}. They have been emailed.",
  "invitedNoEmailTitle": "Invited {{email}}",
  "invitedNoEmailBody": "No email was sent — this deployment has no outbound mail settings. Tell them to sign in and their access will be waiting.",
  "notInvited": "Not invited",
  "inviteError": "Could not invite that person.",
  "rolePlatformOwner": "Platform owner",
  "rolePlatformAdmin": "Platform admin",
  "rolePartnerAdmin": "Partner admin",
  "roleTenantAdmin": "Tenant admin",
  "roleEditor": "Editor",
  "roleDesigner": "Designer",
  "roleViewer": "Viewer",
  "roleDescOwner": "Everything, including granting ownership to others.",
  "roleDescAdmin": "Administers every tenant. Cannot grant platform roles.",
  "roleDescPartnerAdmin": "Administers every customer in this partner book, and who else can manage the book.",
  "roleDescTenantAdmin": "Full control of one tenant, including its access list.",
  "roleDescEditor": "Edits templates, rules and campaigns.",
  "roleDescDesigner": "Edits templates only.",
  "roleDescViewer": "Read-only."
}
